import { Css } from "@homebound/beam";
import { ReactNode } from "react";

export function LabelledText({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label css={Css.gray700.sm.wsnw.$}>
      {label}
      <div css={Css.mt1.sm.gray800.$} aria-label={label}>
        {children}
      </div>
    </label>
  );
}
